// Registro do handler de apresentação de notificações locais — extraído de
// src/features/session/pauseNotification.ts (Etapa 12) para cá na Etapa 14
// porque agora existe uma SEGUNDA notificação local (dailyReminder.ts, o
// lembrete diário de "projeto atual"), que pode disparar sem a usuária ter
// passado pela tela de Sessão nesta execução do app — se o handler só fosse
// registrado como side-effect de importar pauseNotification.ts, uma sessão
// de app onde a usuária só mexe em Preferências (nunca abre a Sessão)
// ficaria sem o handler registrado. Importado uma única vez, sempre, a
// partir de app/_layout.tsx (raiz da árvore, carrega em toda execução).
import { Platform } from 'react-native';
import * as Notifications from 'expo-notifications';

if (Platform.OS !== 'web') {
  Notifications.setNotificationHandler({
    handleNotification: async () => ({
      shouldShowAlert: true,
      shouldPlaySound: true,
      shouldSetBadge: false,
    }),
  });
}
